import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { DefaultLayout, LoggedInLayout, PdfLayout } from "../Layouts/Index";
import {
  MyAccount,
  Pricing,
  Error,
  Filter,
  DashboardShortcuts,
  InteractiveMap,
  DashboardSummary,
  KnownDevelopments,
  MyMarketList,
  SavedSearchList,
  FavoriteLocationList,
  UserSignin,
  ResetPassword,
  FreeAccountConfirmation,
  AccountSuccess,
  SubscriptionSuccess,
  AmenitiesAnalysis,
  InvalidAccess,
  AccountSubscription,
  BuyReport,
  DownloadReport,
  PrivacyPolicy,
  Terms,
  BuyMarketReport,
  MarketPaymentSuccess,
  PurchaseAccountActivation,
  RVParksMarketData,
  DownloadReportDevelopments,
  DownloadReportTransactions,
  UserSubscription
} from "../Pages/Index";
import { ExportProfile } from "../Pages/MarketProfile/ExportProfile";
import { PreviewMarket } from "../Pages/PreviewMarket/PreviewMarket";
import SearchExplorer from "../Pages/SearchExplorer/SearchExplorer";
import DownloadDetailReport from "../Pages/DownloadDetailReport/DownloadDetailReport";
import RVParksList from "../Pages/DashboardShortcuts/RVParksList/RVParksList";
import AdminLandingPage from "../Admin/Pages/AdminLandingPage";
import AddMarketSuccessPage from "../Pages/ActionPages/AddMarketSuccessPage";
import TwofactorAuthentication from "../Pages/Authorization/TwoFactorAuth";
import DeniedAccess from "../Pages/Authorization/DeniedAccess";
import { getAuthInfo } from "../../Utils/utils";

function RouterWrapper(props) {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<DefaultLayout />}>
          <Route index element={<AuthPrivateRouter><Pricing packageFullData={props.packageFullData} /></AuthPrivateRouter>} />
          <Route path="/account-success" element={<AccountSuccess />} />
          <Route
            path="/market-data"
            element={<Pricing packageFullData={props.packageFullData} />}
          />
          <Route path="/bookademo" element={<RVParksMarketData />} />
          <Route path="/signin" element={<AuthPrivateRouter><UserSignin /></AuthPrivateRouter>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/account-confirmation"
            element={<FreeAccountConfirmation />}
          />
          <Route
            path="/subscription-success"
            element={<SubscriptionSuccess />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/invalid-access" element={<InvalidAccess />} />
          <Route
            path="/invalid-access-dashboard"
            element={<InvalidAccess from="dashboard-unauthorised" />}
          />
          <Route path="/preview-market" element={<PreviewMarket />} />
          <Route path="/market-payment-success" element={<MarketPaymentSuccess />} />
          <Route path="/2fa/:secureId" element={<TwofactorAuthentication />} />
          <Route path="/access-denied" element={<DeniedAccess />} />
          <Route path="/add-market-payment-success/:refid" element={<SubscriptionSuccess />} />
          <Route path="/activate-purchase-account" element={<PurchaseAccountActivation />} />
          <Route path="/subscription-cancel" element={<InvalidAccess from="subscription-cancel" />} />
          <Route path="/market-payment-cancel" element={<InvalidAccess from="market-payment-cancel" />} />
          <Route path="*" element={<Error />} />
        </Route>

        <Route
          path="/account-subscription"
          element={
            <AccountSubscription packageFullData={props.packageFullData} />
          }
        />
        <Route
          path="/buy-report"
          element={
            <RequireAuth redirectTo="/invalid-access">
              <SearchExplorer packDetails={props.packageInfo} />
            </RequireAuth>
          }
        />
        <Route>
          <Route
            path="/report-download"
            element={
              <DownloadReport />
            }
          >
            <Route path=":id" element={<DownloadReport />}>
              <Route path=":key" element={<DownloadReport />}></Route>
            </Route>
          </Route>
        </Route>
        <Route>
          <Route
            path="/report-download-developments"
            element={
              <DownloadReportDevelopments />
            }
          >
            <Route path=":id" element={<DownloadReportDevelopments />}>
              <Route path=":key" element={<DownloadReportDevelopments />}></Route>
            </Route>
          </Route>
        </Route>
        <Route>
          <Route
            path="/report-download-transactions"
            element={
              <DownloadReportTransactions />
            }
          >
            <Route path=":id" element={<DownloadReportTransactions />}>
              <Route path=":key" element={<DownloadReportTransactions />}></Route>
            </Route>
          </Route>
        </Route>
        <Route>
          <Route
            path="/report-download-developments"
            element={<DownloadReportDevelopments />}
          >
            <Route path=":id" element={<DownloadReportDevelopments />}>
              <Route
                path=":key"
                element={<DownloadReportDevelopments />}
              ></Route>
            </Route>
          </Route>
        </Route>
        <Route>
          <Route
            path="/report-download-transactions"
            element={<DownloadReportTransactions />}
          >
            <Route path=":id" element={<DownloadReportTransactions />}>
              <Route
                path=":key"
                element={<DownloadReportTransactions />}
              ></Route>
            </Route>
          </Route>
        </Route>
        <Route>
          <Route path="/detail-report" element={<DownloadDetailReport />}>
            <Route path=":id" element={<DownloadDetailReport />}>
              <Route path=":key" element={<DownloadDetailReport />}></Route>
            </Route>
          </Route>
        </Route>
        <Route element={<PdfLayout />}>
          <Route path="/rvparksprofile-pdf" element={<ExportProfile />}>
            <Route path=":id" element={<ExportProfile />}>
              <Route path=":lat" element={<ExportProfile />}>
                <Route path=":lng" element={<ExportProfile />}>
                  <Route path=":key" element={<ExportProfile />}></Route>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
        <Route
          path="/buy-market-report"
          element={<BuyMarketReport packageFullData={props.packageFullData} />}
        />
        <Route
          element={<LoggedInLayout packageFullData={props.packageFullData} />}
        >
          <Route
            path="/market-search"
            index
            element={
              <RequireAuth redirectTo="/invalid-access">
                <SearchExplorer packDetails={props.packageInfo}/>
              </RequireAuth>
            }
          />

          <Route
            path="/sample-market"
            index
            element={
              <RequireAuth redirectTo="/invalid-access">
              <DemoMarketPrivateRoute>
                <SearchExplorer demoMarket packDetails={props.packageInfo} />
                </DemoMarketPrivateRoute>
              </RequireAuth>
            }
          />
          <Route
            path="/my-account"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <MyAccount packDetails={props.packageInfo} />
              </RequireAuth>
            }
          />
          <Route
            path="/filter"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <Filter />
              </RequireAuth>
            }
          />
          <Route
            path="/market-dashboard/"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <DashboardShortcuts />
              </RequireAuth>
            }
          >
            <Route path="market-analysis/" element={<DashboardSummary />}>
              <Route path=":id" element={<DashboardSummary />} />
            </Route>
            <Route path="rvparks-lists/" element={<RVParksList />}>
              <Route path=":id" element={<RVParksList />} />
            </Route>
            <Route path="interactive-map/" element={<InteractiveMap />}>
              <Route path=":id" element={<InteractiveMap />} />
            </Route>
            <Route path="known-development/" element={<KnownDevelopments />}>
              <Route path=":id" element={<KnownDevelopments />} />
            </Route>
          </Route>
          <Route
            path="/market-amenities"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <AmenitiesAnalysis />
              </RequireAuth>
            }
          />
          <Route
            path="/my-market"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <MyMarketList packDetails={props.packageInfo} />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/user-account/:id"
            element={
              <RequireAdminAuth redirectTo="/invalid-access">
               <MyAccount packDetails={props.packageInfo} />
              </RequireAdminAuth>
            }
          />
          <Route
            path="/admin/user-subscription/:userid/:orderid"
            element={
              <RequireAdminAuth redirectTo="/invalid-access">
               <UserSubscription pacDetails={props.packageInfo} />
              </RequireAdminAuth>
            }
          />
          <Route
            path="/account/user-subscription/:orderid"
            element={
              <RequireAdminAuth redirectTo="/invalid-access">
               <UserSubscription packDetails={props.packageInfo} />
              </RequireAdminAuth>
            }
          />
          <Route
            path="/saved-search"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <SavedSearchList />
              </RequireAuth>
            }
          />
          <Route
            path="/fav-location"
            element={
              <RequireAuth redirectTo="/invalid-access">
                <FavoriteLocationList />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/user-management"
            element={
              <RequireAdminAuth redirectTo="/invalid-access">
                <AdminLandingPage  packDetails={props.packageFullData} />
              </RequireAdminAuth>
            }
          />

            <Route path="admin/user-management" element={<AdminLandingPage />}>
              <Route  element={<AdminLandingPage />} />
            </Route>

        </Route>
      </Routes>
    </React.Fragment>
  );
}
function RequireAuth({ children, redirectTo }) {
  return getAuthInfo().isAuthenticated ? children : <Navigate to={redirectTo} />;
}

function AuthPrivateRouter({children}) {
  const authInfo = getAuthInfo();  
  return authInfo.isAuthenticated ? <Navigate to={authInfo.isAdmin ? "/admin/user-management": "/market-search"} /> : children;
  var userDetails =
  localStorage.getItem("user") !== null ? localStorage.getItem("user") : null;
  var isAuthenticated =userDetails !== null && JSON.parse(userDetails).accessKey !== null? true: false;
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

const DemoMarketPrivateRoute = ({children})=>{
  var userDetails =
  localStorage.getItem("user") !== null ? localStorage.getItem("user") : null;
  const isFreeUser =  userDetails !== null && JSON.parse(userDetails).usertype==="Free"
  ? true
  : false; 
  return isFreeUser ? children : <Navigate to={"/market-search"} />
}


function RequireAdminAuth({ children, redirectTo }) {
  return getAuthInfo().isAuthenticated ? children : <Navigate to={redirectTo} />;
}

export default RouterWrapper;
